require('../../styles/ai/dimensions_logo.scss');
require('../../styles/ai/user_login.scss');

const svgIcons    = require('../icons/svg_icons');

module.exports = `
  <div class="user-login">
    <div class="div">
      <div class="logos-wrapper">
        <i class="dimensions-logo"></i>
        <i>${svgIcons.arrow_right}</i>
        <i>${svgIcons.readcube}</i>
      </div>
      <p class="text-wrapper">Sign in or Register</p>
      <p class="p">
        Chat with PDF is brought to you by an integration between Dimensions and Papers - the simplest way to read and manage the research literature you discover in Dimensions.
      </p>
      <div class="frame-wrapper">
        <div class="button-wrapper">
          <button id="sign-up" class="button">
            <div class="button-text">Try Papers for FREE</div>
          </button>
        </div>
        <p class="sign-in-wrapper">
          <span>or </span><a id="sign-in">Sign in to an existing Papers account</a>
        </p>
      </div>
    </div>
  </div>
`;